import getEndPoint from './getEndpoint';
import actions from '../actions';
import store from '../store';
import heap from './heap';

export async function getAccessToken(env, data, secret) {
    const endPoint = getEndPoint(env, 'apigeeOAuth');

    try {
        const response = await fetch(`${endPoint}oauth/token`, {
            method: 'POST',
            body: 'grant_type=client_credentials',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: secret
            }
        });

        if (response.status === 200 || response.status === 401) {
            if (response.status === 401) {
                heap.track('customerPortal', { error: 401, accessCode: data.accessCode });
                store.dispatch(actions.apigee.error(response));
            } else {
                const tokenResponse = await response.json();
                authorizeCustomer(env, data, tokenResponse.access_token);
            }
        } else {
            store.dispatch(actions.apigee.error(response));
        }
    } catch (err) {
        store.dispatch(actions.apigee.error(err));
    }
}

async function authorizeCustomer(env, data, access_token) {
    const endPoint = getEndPoint(env, 'apigeeOAuth');

    try {
        const response = await fetch(`${endPoint}v1/btcustomerportalserviceoauth`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                Authorization: 'Bearer ' + access_token
            }
        });
        if (response.status === 200 || response.status === 401) {
            if (response.status === 401) {
                heap.track('customerPortal', { error: 401, accessCode: data.accessCode });
            }
            let res = await response.json();
            res.access_token = access_token;
            store.dispatch(actions.apigee.receiveAccessToken(res));
        } else {
            store.dispatch(actions.apigee.error(response));
        }
    } catch (err) {
        store.dispatch(actions.apigee.error(err));
    }
}



// WEBPACK FOOTER //
// ./src/modules/apigee.js